import gql from 'graphql-tag';

const BRAND_PRESET_ACTION = gql`
  mutation brandPresetActions($brandPresetId: String!, $action: BrandActions!) {
    brandPresetActions(brandPresetId: $brandPresetId, action: $action) {
      brandPresetId
    }
  }
`;

const setDefaultBrandPresetMutation = () => ({
  mutation: BRAND_PRESET_ACTION,
  module: 'organisations',
  buildVariables: ({ brandPresetId, action

  }) => ({
    brandPresetId,
    action
  })
});

export default setDefaultBrandPresetMutation;